import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  value: {
    userSettings: [],
    fieldSettings: { fieldSetId: 0, columns: [] },
    loaded: false
  }
};
const userSettingInfoSlice = createSlice({
  name: "userSettingInfo",
  initialState,
  reducers: {
    getUserSettings: (state, action) => {
      state.value = {
        userSettings: action.payload,
        fieldSettings: { fieldSetId: 0, columns: [] },
        loaded: true
      };
    },
    updateUserFieldSettings: (state, action) => {
      console.log(action);
      state.value = {
        userSettings: state.value.userSettings,
        fieldSettings: action.payload,
        loaded: state.value.loaded
      };
    },
    updateOneHeaderSetting: (state, action) => {
      let fieldSettings = { ...state.value.fieldSettings };
      console.log(action.payload);
      console.log(fieldSettings);
      let fs = fieldSettings.columns = action.payload.columns;
      console.log(fs);
      state.value = {
        userSettings: state.value.userSettings,
        fieldSettings,
        loaded: state.value.loaded
      };
      console.log(fieldSettings);
    }
  }
});
export const { getUserSettings, updateUserFieldSettings, updateOneHeaderSetting } = userSettingInfoSlice.actions;
export default userSettingInfoSlice.reducer;
